import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { ReactComponent as Star } from '../../../Assets/images/icons/star-single.svg';
import './ScheduleDemo.scss';
import Validation from './Validation';
import axios from "axios";
import * as Constants from '../../../Common/Constants';
import CountryResponse from './country'

const ScheduleDemoAr = () => {
    const navigate = useNavigate();
    const [formERR, setFormERR] = useState(null);
    const initialFormState = {
        FirstName: '',
        LastName: '',
        Email: '',
        Phone: '',
        Country: '',
        CountryId: '0',
        Product: '',
        ProductId: '0',
        Company: '',
        JobTitle: '',
        SetupType: '',
        SetupTypeId: '0',
        AgreeToPrivacy: false
    };
    const [values, setValues] = useState(initialFormState);
    const [countries, setCountries] = useState(null);

    // const getCountryList = async () => {
    //     //start loader
    //     axios.get(Constants.GET_COUNTRY_LIST, {}).then(response => {
    //         if (response !== null && response.data !== null && response.data.Data !== null && response.data.Data.Countries !== null) {
    //             setCountries(response.data.Data.Countries);
    //         }
    //     }).catch((error) => {
    //         console.log("Failed", error);
    //     }).finally(() => {
    //         //stop loader
    //     });
    // };

    const getCountryList = async () => {
        var response = CountryResponse;
        //start loader

        if (response !== null &&  response.Data !== null && response.Data.Countries !== null) {

            response.Data.Countries.sort((a, b) => a.CountryName.localeCompare(b.CountryName));
            setCountries(response.Data.Countries);
        }
    };

    const handleChange = (e) => {
        if (e.target.name === "Country") {
            setValues({ ...values, ["CountryId"]: e.target.value, [e.target.name]: e.target.selectedOptions[0].text });
        } else if (e.target.name === "Product") {
            setValues({ ...values, ["ProductId"]: e.target.value, [e.target.name]: e.target.selectedOptions[0].text });
        } else if (e.target.name === "SetupType") {
            setValues({ ...values, ["SetupTypeId"]: e.target.value, [e.target.name]: e.target.selectedOptions[0].text });
        } else if (e.target.name === "AgreeToPrivacy") {
            setValues({ ...values, [e.target.name]: e.target.checked });
        } else {
            setValues({ ...values, [e.target.name]: e.target.value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormERR(null);
        const _err = Validation(values);
        console.log(_err);
        if (Object.keys(_err).length === 0) {
            //start loader
            try {
                console.log(values);
                var requestJson = {
                    "Request": {
                        ...values
                    }
                }
                //Call Zoho API to push data
                axios.post(Constants.SAVE_DEMO_REQUEST, requestJson).then(response => {
                    if(response != null && response.data !== null && response.data.Data !== null && response.data.Status === 0) {
                        navigate("/ar/thank-you");
                    } else {
                        setFormERR(response.data.ErrorMessage);
                    }
                }).catch((error) => {
                    console.log("Failed", error);
                }).finally(() => {
                    //stop loader
                });
            } catch (error) {
                console.log('Failed:', error);
            } finally {
                //stop loader
                // Reset formData to initial state
                setValues(initialFormState);
            }
        } else {
            setFormERR("يرجى التأكد من استكمال جميع الحقول المطلوبة بمعلومات صحيحة ودقيقة.");
        }
    };

    useEffect(() => {
        getCountryList();
    }, []);

    return (
        <div dir='rtl' className="container">
            <section className='aug-schedule-demo'>
                <div className="row">
                    <div className="col-lg-5 col-md-12">
                        <h3 className="aug-schedule-demo__title">ماذا تتوقع:</h3>
                        <ul className='mb-0 aug-schedule-demo__list'>
                            <li className='d-flex'><Star className='ms-2' /> استمتع بتجربة عرض تجريبي بقيادة الخبراء لبرنامج الذكاء الاصطناعي الصوتي الطبي الخاص بنا</li>
                            <li className='d-flex'><Star className='ms-2' />استشارة خالية من الالتزام على Augnito خيارات الاشتراك</li>
                            <li className='d-flex'><Star className='ms-2' />استكشف قدرات وفوائد منتجاتنا القوية</li>
                            <li className='d-flex mb-0'><Star className='ms-2' />استكشف الأسعار المخصصة للمؤسسات</li>
                        </ul>
                    </div>
                    <div className="col-md-12 col-lg-7">
                        <div className='aug-schedule-demo__form'>
                            <h3 className="aug-schedule-demo__title">جدولة عرض توضيحي</h3>
                            {formERR && <div className='aug-schedule-demo__error'>{formERR}</div>}
                            <form onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className='col-md-6 col-12'>
                                        <div className="mb-4">
                                            <input type="text" className="form-control" placeholder="الاسم الأول" id="FirstName" name="FirstName" value={values.FirstName} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <div className="mb-4">
                                            <input type="text" className="form-control" placeholder="اسم العائلة" id="LastName" name="LastName" value={values.LastName} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <div className="mb-4">
                                            <input type="email" className="form-control" placeholder="البريد الإلكتروني" id="Email" name="Email" value={values.Email} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <div className="mb-4">
                                            <input type="number" className="form-control" placeholder="الهاتف" id="Phone" name="Phone" value={values.Phone} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <div className="mb-4">
                                            <select id="Country" name="Country" value={values.CountryId} className="form-select form-control" onChange={handleChange}>
                                                <option value='0' defaultValue>الدولة</option>
                                                {countries !== null ? countries.map((country) => (
                                                    <option value={country.Id} key={country.Id}>
                                                        {country.CountryName}
                                                    </option>
                                                )) : ""
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <div className="mb-4">
                                            <select id="Product" name='Product' value={values.ProductId} className="form-select form-control" onChange={handleChange}>
                                                <option value="0" defaultValue>اختيار منتج</option>
                                                <option value="2">Omni</option>
                                                <option value="1">Spectra</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <div className="mb-4">
                                            <input type="text" className="form-control" placeholder="اسم الشركة" id="Company" name="Company" value={values.Company} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                        <div className="mb-4">
                                            <input type="text" className="form-control" placeholder="المسمى الوظيفي" id="JobTitle" name="JobTitle" value={values.JobTitle} onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className="mb-4">
                                            <select id="SetupType" name='SetupType' value={values.SetupTypeId} className="form-select form-control" onChange={handleChange}>
                                                <option value="0" defaultValue>نوع الإعداد</option>
                                                <option value="1">فردي </option>
                                                <option value="2">عيادة تشخيصية/صغيرة </option>
                                                <option value="3">مستشفى </option>
                                                <option value="4">شركة البرمجيات </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className="form-check">
                                            <input type="checkbox" className="form-check-input" id="AgreeToPrivacy" name='AgreeToPrivacy' checked={values.AgreeToPrivacy} onChange={handleChange} />
                                            <label className="form-check-label me-1" htmlFor="exampleCheck1"> بالنقر على إرسال، فإنك توافق على جمع معلوماتك الشخصية واستخدامها لتلقي تفاصيل حول منتجاتنا وخدماتنا. كما توافق على استلام رسائل تسويقية منا عبر البريد الإلكتروني أو الرسائل النصية القصيرة أو غيرها من القنوات الرقمية. يمكنك سحب موافقتك في أي وقت باتباع التعليمات الواردة في رسائلنا أو بالتواصل معنا مباشرةً. لمزيد من المعلومات، يُرجى الاطلاع على بنا <a className='PrivacyPolicyLink' href='https://augnito.ai/legal/augnito-privacy-policy' target='_blank'>سياسة الخصوصية الخاصة.</a>*</label>
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <button type="submit" className="btn btn-primary w-100">إرسال</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ScheduleDemoAr;
